const UNITS = ['', 'un', 'deux', 'trois', 'quatre', 'cinq', 'six', 'sept', 'huit', 'neuf',
  'dix', 'onze', 'douze', 'treize', 'quatorze', 'quinze', 'seize', 'dix-sept', 'dix-huit', 'dix-neuf'];

const TENS = ['', 'dix', 'vingt', 'trente', 'quarante', 'cinquante', 'soixante', 'soixante', 'quatre-vingt', 'quatre-vingt'];

function convertBelow100(n) {
  if (n < 20) return UNITS[n];
  const ten = Math.floor(n / 10);
  const unit = n % 10;

  if (ten === 7 || ten === 9) {
    // 70-79: soixante-dix..., 90-99: quatre-vingt-dix...
    const sub = n - (ten === 7 ? 60 : 80);
    if (sub === 1 && ten === 7) return 'soixante et onze';
    return TENS[ten] + '-' + UNITS[sub];
  }

  if (unit === 0) {
    return ten === 8 ? 'quatre-vingts' : TENS[ten];
  }
  if (unit === 1 && ten !== 8) {
    return TENS[ten] + ' et un';
  }
  return TENS[ten] + '-' + UNITS[unit];
}

function convertBelow1000(n) {
  if (n < 100) return convertBelow100(n);
  const hundreds = Math.floor(n / 100);
  const remainder = n % 100;
  let result = hundreds === 1 ? 'cent' : UNITS[hundreds] + ' cent';
  if (remainder === 0 && hundreds > 1) return result + 's';
  if (remainder > 0) result += ' ' + convertBelow100(remainder);
  return result;
}

/**
 * Converts a number (integer, up to 999 999 999 999) to French words.
 * Follows standard French number spelling rules.
 */
export function numberToFrench(n) {
  if (n === null || n === undefined || n === '' || isNaN(n)) return '';
  n = Math.round(Number(n));
  if (n === 0) return 'zéro';
  if (n < 0) return 'moins ' + numberToFrench(-n);

  const parts = [];

  const milliards = Math.floor(n / 1_000_000_000);
  if (milliards > 0) {
    parts.push(milliards === 1 ? 'un milliard' : convertBelow1000(milliards) + ' milliards');
    n %= 1_000_000_000;
  }

  const millions = Math.floor(n / 1_000_000);
  if (millions > 0) {
    parts.push(millions === 1 ? 'un million' : convertBelow1000(millions) + ' millions');
    n %= 1_000_000;
  }

  const milliers = Math.floor(n / 1000);
  if (milliers > 0) {
    parts.push(milliers === 1 ? 'mille' : convertBelow1000(milliers) + ' mille');
    n %= 1000;
  }

  if (n > 0) {
    parts.push(convertBelow1000(n));
  }

  let result = parts.join(' ');
  // Capitalize first letter
  return result.charAt(0).toUpperCase() + result.slice(1);
}

/**
 * Converts a euro amount to French words with "euros" suffix.
 * Example: 450000 → "Quatre cent cinquante mille euros"
 */
export function eurosToFrench(n) {
  if (n === null || n === undefined || n === '' || isNaN(n)) return '';
  const rounded = Math.round(Number(n));
  if (rounded === 0) return 'Zéro euro';
  if (rounded === 1 || rounded === -1) return numberToFrench(n) + ' euro';
  return numberToFrench(n) + ' euros';
}
